import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth-service';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { User } from './models/user';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  user: User | null= null;
  menuConfig: any = environment.menuConfig;

  constructor(public authService: AuthService, public router: Router){ 

    
    const user = localStorage.getItem('user');
    if (user) {
      this.authService.setCurrentUser(JSON.parse(user));
    }


  }
  ngOnInit(): void {
    this.authService.currentUser$.pipe().subscribe(user =>{
     
      this.user = user;
    })
  }
  isRobiSelected(){
    return this.router.url == '/' || this.router.url == 'robi';
  }
  isCollapsed = true;
  logout(){
    this.authService.SignOut();
  }
  isInRoles(roles : string[]){ 
    
    if (roles == null || roles == undefined || roles?.length == 0) {
      return false;
    }

    if (this.user?.roles.some(r => roles.includes(r))) {
      return true;
    }

    return false;
  }

  visible = false;

  open(): void {
    this.visible = true;
  }

  close(): void {
    this.visible = false;
  }
}

